export const appConfig = {
	locale: 'en-gb',
	initial: {
		unit: 'm',
	},
};

export const permissionsConfig = {
	roles: {
		UiAdmin: [
			'createAnnotation',
			'createTask',
			'editOpportunity',
			'saveDraft',
			'viewAnalyzed',
			'viewAnnotations',
			'viewTasks',
			'viewUnverified',
		],
	},
};

export const spendConfig = {
	initial: {
		sort: 'value',
		filters: [],
		dimension: 'category',
	},
	aggregateOtherAt: 100,
	spend: {
		charts: [
			{
				type: 'BAR',
				inverted: false,
				dimensions: ['category'],
				series: [
					{
						property: 'value',
						label: 'Spend',
					},
				],
			},
		],
	},
};

export const demoChartConfig = {
	savings: {
		advancedCharts: [
			{
				name: 'VolumeLeverage',
				order: 0,
				charts: [
					{
						type: 'STACKED',
						inverted: true,
						defaultDimensions: ['supplier', 'category'],
						maxCategories: 20,
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [20, 500],
						limitOrders: ['desc', 'desc'],
						limitValues: ['totalSpend'],
					},
					{
						type: 'STACKED',
						inverted: true,
						defaultDimensions: ['supplier', 'receivingEntity'],
						maxCategories: 20,
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [20, 500],
						limitOrders: ['desc', 'desc'],
						limitValues: ['totalSpend'],
					},
					{
						type: 'STACKED',
						inverted: false,
						defaultDimensions: ['receivingEntity', 'supplier'],
						maxCategories: 20,
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [500, 20],
						limitOrders: ['desc', 'desc'],
						limitValues: ['totalSpend'],
					},
					{
						type: 'STACKED',
						inverted: false,
						defaultDimensions: ['receivingEntity', 'category'],
						maxCategories: 20,
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [500, 20],
						limitOrders: ['desc', 'desc'],
						limitValues: ['totalSpend'],
					},
					{
						type: 'STACKED',
						inverted: false,
						defaultDimensions: ['category', 'receivingEntity'],
						maxCategories: 20,
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [20, 500],
						limitOrders: ['desc', 'desc'],
						limitValues: ['totalSpend'],
					},
					{
						type: 'STACKED',
						inverted: false,
						defaultDimensions: ['category', 'supplier'],
						maxCategories: 20,
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [20, 20],
						limitOrders: ['desc', 'desc'],
						limitValues: ['totalSpend'],
					},
				],
			},
			{
				name: 'GlobalSourcing',
				order: 1,
				charts: [
					{
						type: 'STACKED',
						inverted: false,
						defaultDimensions: ['supplierCountry', 'category'],
						maxCategories: 20,
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [20, 500],
						limitOrders: ['desc', 'desc'],
						limitValues: ['totalSpend'],
					},
					{
						type: 'STACKED',
						inverted: false,
						defaultDimensions: ['supplierCountry', 'receivingEntity'],
						maxCategories: 20,
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [20, 500],
						limitOrders: ['desc', 'desc'],
						limitValues: ['totalSpend'],
					},
				],
			},
			{
				name: 'DemandManagement',
				order: 2,
				charts: [
					{
						type: 'BAR',
						inverted: false,
						defaultDimensions: ['category'],
						maxCategories: 20,
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [20],
						limitOrders: ['desc'],
						limitValues: ['totalSpend'],
					},
					{
						type: 'BAR',
						inverted: false,
						defaultDimensions: ['receivingEntity'],
						maxCategories: 20,
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [20],
						limitOrders: ['desc'],
						limitValues: ['totalSpend'],
					},
				],
			},
			{
				name: 'PricingInconsistencies',
				order: 3,
				charts: [
					{
						type: 'BAR',
						inverted: false,
						defaultDimensions: ['receivingEntity'],
						series: [
							{
								property: 'avgPrice',
								label: 'Average Price',
							},
						],
						limits: [100],
						limitOrders: ['desc'],
						limitValues: ['avgPrice'],
					},
					{
						type: 'SCATTER',
						inverted: false,
						defaultDimensions: ['supplier', 'sku'],
						series: [
							{
								property: 'avgNetUnitPrice',
								label: 'Price',
							},
						],
						limits: [20, 500],
						limitOrders: ['desc', 'desc'],
						limitValues: ['avgNetUnitPrice'],
					},
					{
						type: 'BAR',
						inverted: false,
						defaultDimensions: ['sku'],
						series: [
							{
								property: 'totalSpend',
								label: 'Spend',
							},
						],
						limits: [100],
						limitOrders: ['desc'],
						limitValues: ['totalSpend'],
					},
				],
			},
			{
				name: 'SkuStandardisation',
				order: 4,
				charts: [
					{
						type: 'STACKED',
						inverted: false,
						defaultDimensions: ['category', 'sku'],
						series: [
							{
								property: 'countDistinctSku',
								label: '# unique line items',
							},
						],
						limits: [100, 100],
						limitOrders: ['desc', 'desc'],
						limitValues: ['totalSpend'],
					},
					{
						type: 'LINE',
						inverted: false,
						defaultDimensions: ['sku'],
						maxCategories: 20,
						extremes: [0, 1],
						series: [
							{
								property: 'pctPrimaryOfSecondaryTotalSpend',
								accumulate: 'DESC',
								sort: 'ASC',
							},
						],
						limits: [100],
						limitOrders: ['desc'],
						limitValues: ['pctPrimaryOfSecondaryTotalSpend'],
					},
				],
			},
		],
	},
};

export const opportunitiesConfig = {
	inputs: [
		{
			key: 'difficultyToImplement',
			type: 'range',
			min: 1,
			max: 5,
		},
		{
			key: 'resourcesNeeded',
			type: 'range',
			min: 0,
			max: 20,
		},
		{
			key: 'resourcesAvailable',
			type: 'range',
			min: 0,
			max: 20,
		},
		{
			key: 'timeToImplement',
			type: 'range',
			min: 1,
			max: 18,
		},
		{
			key: 'profitAndLossImpact',
			type: 'range',
			min: 1,
			max: 18,
		},
		{
			key: 'impactRealisation',
			type: 'range',
			min: 0,
			max: 10,
		},
	],
};

export const anonymizationOptionsConfig = [
	{
		value: 1,
		title: 'Option 1. All data to Knowledge Base',
		description: 'Use Company Procurement Variables.',
	},
	{
		value: 2,
		title: 'Option 2. Suppliers anonymised',
		description:
			'(i) Use the Company Procurement Variables for the purposes of, and to the extent reasonably necessary, to perform the Services in accordance with the Agreement; and (ii) transform the Company Procurement Variables into ranges of Procurement Variables (rather than specific Procurement Variables) and to use such ranges of Procurement Variables.',
	},
	{
		value: 3,
		title: 'Option 3. Benchmarks only stored',
		description:
			'(i) Use the Company Procurement Variables for the purposes of, and to the extent reasonably necessary, to perform the Services in accordance with the Agreement; and (ii) incorporate the Company Procurement Variables into formulae, and/ or to use the Company Procurement Variables to inform the development and/ or construction by AlixPartners of such formulae, to be used in the performance of services comprising procurement comparisons and/ or analysis in contrast for other parties and the provision of advice in relation to such services.',
	},
	{
		value: 4,
		title: 'Option 4. No data stored',
		description:
			'Select this option if there is no Clause 13.3 or if it is included there is specific exclusion to any data being stored.',
	},
];

export const featureFlagsConfig = {};
